<template>
  <div class="col-lg-12 col-md-12" v-if="campaignDetails != null">
    <div v-if="loadingOverlay === true">
      <div class="lds-dual-ring"></div>
    </div>
    <div v-if="campaignStats != null">
      <div class="row" style="margin-left: 5px;">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card
            type="warning"
            icon="nc-icon nc-globe"
            small-title="Influencers"
            :title="String(campaignStats.influencerStats.length)"
          >
            <div class="stats" slot="footer">
              <i class="nc-icon nc-refresh-69"></i>
              Last Updated
            </div>
          </stats-card>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card
            type="warning"
            icon="nc-icon nc-globe"
            small-title="Posts"
            :title="String(campaignStats.postCount)"
          >
            <div class="stats" slot="footer">
              <i class="nc-icon nc-refresh-69"></i>
              Last Updated
            </div>
          </stats-card>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card
            type="warning"
            icon="nc-icon nc-globe"
            small-title="Impressions"
            :title="String(campaignStats.impressionsTotal)"
          >
            <div class="stats" slot="footer">
              <i class="nc-icon nc-refresh-69"></i>
              Last Updated
            </div>
          </stats-card>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card
            type="warning"
            icon="nc-icon nc-globe"
            small-title="Reach"
            :title="String(campaignStats.reachTotal)"
          >
            <div class="stats" slot="footer">
              <i class="nc-icon nc-refresh-69"></i>
              Last Updated
            </div>
          </stats-card>
        </div>
      </div>
      <div class="row" v-if="postList.length > 0">
        <div class="col-md-12">
          <div class="card">
            <div
              class="card-header"
              style="padding-bottom:0px; margin-bottom:0px;"
            >
              <div>
                <h5
                  class="title"
                  style="padding-bottom:0px;  margin-bottom:0px;"
                >
                  Recent Posts
                </h5>
                <hr />
              </div>

              <div style="top: 0px; right: 10px; position:absolute; ">
                <p-button
                  @click="
                    $router.push(
                      `/influencer-campaign/post/search/${$route.params.campaignId}`
                    )
                  "
                  style="margin-top:15px;"
                  type="info"
                  link
                  >view all</p-button
                >
              </div>
            </div>

            <div class="card-body">
              <div
                class="post-preview"
                v-for="post in postList"
                :key="post.shortcode"
              >
                <span v-if="post.cached == true">
                  <img
                    :src="post.imageUrlCache"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.shortcode}`)"
                  />
                </span>
                <span v-else>
                  <img
                    :src="post.imageUrl"
                    class="img-row"
                    alt
                    @click="$router.push(`/instagram/post/${post.shortcode}`)"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="influencerList.length > 0">
        <div class="col-md-12">
          <div class="card" style="padding-left:15px;">
            <div class="card-header">
              <h5 class="title">Influencers</h5>
              <hr />
            </div>

            <div class="card-body table-responsive table-full-width">
              <el-table :data="influencerList">
                <el-table-column
                  label="Influencer"
                  class-name="action-buttons td-actions"
                  class="center-align"
                  :header-row-style="{ textAlign: 'center' }"
                >
                  <template slot-scope="props">
                    <div style="width: 100%; text-align: center;">
                      <img
                        :src="props.row.profilePicCache"
                        width="60px"
                        v-if="props.row.profilePicCache !== undefined"
                      />

                      <img
                        :src="props.row.profilePic"
                        width="60px"
                        @error="profilePicLoadCache(props.row.instagramProfile)"
                        v-else
                      />

                      <br />
                      @{{ props.row.instagramProfile }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Followers" class="center-align">
                  <template slot-scope="props">
                    <div style="width: 100%; text-align: center;">
                      {{ props.row.followerCount }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Posts" class="center-align">
                  <template slot-scope="props">
                    <div style="width: 100%; text-align: center;">
                      {{ props.row.postCount }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Date" class="center-align">
                  <template slot-scope="props">
                    <div
                      style="width: 100%; text-align: center;"
                      v-if="props.row.dateTakenString !== undefined"
                    >
                      {{ props.row.dateTakenString }}
                    </div>
                    <div style="width: 100%; text-align: center;" v-else>
                      {{ props.row.dateAddedString }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="ER" class="center-align">
                  <template slot-scope="props">
                    <div style="width: 100%; text-align: center;">
                      {{ (props.row.engagementRate * 100).toFixed(2) }}%
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Likes" class="center-align">
                  <template slot-scope="props">
                    <div style="width: 100%; text-align: center;">
                      {{ props.row.avgLikes }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Comments" class="center-align">
                  <template slot-scope="props">
                    <div style="width: 100%; text-align: center;">
                      {{ props.row.avgComments }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label class="center-align">
                  <template slot-scope="props">
                    <p-button
                      style="margin: 3px; "
                      type="info"
                      icon
                      round
                      outline
                      @click="
                        $router.push(
                          '/influencer-campaign/influencer/' +
                            props.row.candidateId
                        )
                      "
                      v-tooltip="'Influencer Details'"
                    >
                      <i class="fas fa-portrait"></i>
                    </p-button>
                    <p-button
                      style="margin: 3px; "
                      type="info"
                      round
                      outline
                      icon
                      @click="
                        $router.push(
                          `/influencer-campaign/post/search/${$route.params.campaignId}/?instagram=${props.row.instagramProfile}`
                        )
                      "
                      v-tooltip="'Campaign Posts'"
                    >
                      <i class="far fa-images"></i>
                    </p-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <card></card>
  </div>
  <div v-else>
    <div class="lds-dual-ring"></div>
  </div>
</template>
<script>
import firebase from "firebase";

import { mapGetters, mapActions } from "vuex";
import { Card, Checkbox, Button } from "@/components/UIComponents";
import ChartCard from "@/components/UIComponents/Cards/ChartCard";
import StatsCard from "@/components/UIComponents/Cards/StatsCard";
import { Badge } from "@/components/UIComponents";
import Loading from "@/components/Dashboard/Layout/LoadingMainPanel.vue";

import _ from "underscore";
//import TaskList from "./Widgets/TaskList";

import {
  userLoadApi,
  userRelatedProfilesApi,
  fbGraphCreateProfile,
  fbGraphInstagramCheck,
  influencerCampaignAnalyticsReadApi,
  influencerCampaignReadApi,
  influencerCollabPostSearchApi,
  instagramProfileCacheApi,
} from "@/config/appSettings";
import axios from "axios";
export default {
  name: "FbAuth",
  components: {
    Card,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    StatsCard,
    ChartCard,
  },

  data() {
    return {
      isConnected: false,
      isTeam: null,
      isClient: null,
      isInfluencer: null,
      profileDetails: null,
      auth: null,
      relatedProfiles: null,
      noAuthProfiles: [],
      campaignDetails: null,
      campaignStats: null,
      loadingOverlay: false,
      loadingOverlayText: null,
      postList: [],
      influencerList: [],
    };
  },
  computed: {
    ...mapGetters(["profileStore"]),
  },
  methods: {
    async setProfileType() {
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }
      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
            return;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            console.log("ERROR:", err);
          }
        }
      }
    },
    async profilePicLoadCache(instagramProfile) {
      try {
        let profileCacheUrl = `${instagramProfileCacheApi}/?usertoken=${this.auth}&instagram=${instagramProfile}`;
        ///console.log("PROFILE CACHE:", profileCacheUrl);
        let profileCacheResponse = await axios.get(profileCacheUrl);
        //console.log(`LOADING ${instagramProfile}`, profileCacheResponse.data);
      } catch (err) {
        console.log("ERR", err);
      }
    },
    async getRelatedProfiles() {
      //console.log("RELATED PROFILES:", this.relatedProfileStore);
      try {
        if (this.isTeam !== true) {
          if (this.relatedProfileStore === false) {
            let relatedProfileResponse = await axios.get(
              `${userRelatedProfilesApi}/?usertoken=${this.auth}`
            );
            this.relatedProfiles = relatedProfileResponse.data.result;
          } else {
            this.relatedProfiles = this.relatedProfileStore;
          }
          //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
        }
      } catch (err) {
        console.log("ERR", err);
      }
    },
    async checkNoAuthProfiles() {
      try {
        if (this.relatedProfiles.length > 0) {
          let instagramProfileString = this.relatedProfiles.join(",");
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );
          //console.log("RELATED PROFILE AUTH CHECK:", noAuthProfileCheckResponse);
          if (noAuthProfileCheckResponse.data.exists === false) {
            this.noAuthProfiles = noAuthProfileCheckResponse.data.result;
          }
        }
      } catch (err) {
        console.log("ERR", er);
      }
    },
    async loadCampaignStats() {
      //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
      try {
        let campaignStatsUrl = `${influencerCampaignAnalyticsReadApi}/?usertoken=${this.auth}&campaign=${this.$route.params.campaignId}`;
        //console.log("CAMPAIGN STATS URL:", campaignStatsUrl);
        let campaignAnalyticsResponse = await axios.get(campaignStatsUrl);
       
        if (campaignAnalyticsResponse.data.success === true) {
          this.campaignStats = campaignAnalyticsResponse.data.result;

          this.influencerList = _.sortBy(
            campaignAnalyticsResponse.data.result.influencerStats,
            "dateAdded"
          ).reverse();
        
          return;
        }
        this.loadingText = "There was a stats error. Refresh page.";
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadCampaign() {
      try {
        //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
        let campaignLoadResponse = await axios.get(
          `${influencerCampaignReadApi}/?usertoken=${this.auth}&campaign=${this.$route.params.campaignId}`
        );
        /*console.log(
        "HERE IS THE CAMPAIGN LOAD RESPONSE:",
        campaignLoadResponse.data
      );*/
        if (campaignLoadResponse.data.success === true) {
          this.campaignDetails = campaignLoadResponse.data.result;

          return;
        }
        this.loadingText = "There was an error loading. Refresh page.";
      } catch (err) {
        console.log("ERR", err);
      }
    },
    async loadPosts() {
      try {
        let searchUrl = `${influencerCollabPostSearchApi}/?usertoken=${this.auth}&campaign=${this.$route.params.campaignId}`;

        let instagramPostResponse = await axios.get(searchUrl);

        //console.log("POST LIST :", instagramPostResponse.data);

        if (instagramPostResponse.data.success === true) {
          //console.log("SETTING POST LIST:");
          let recentPosts = _.sortBy(
            instagramPostResponse.data.result,
            "dateAdded"
          ).reverse();
          this.postList = recentPosts.slice(0, 7);
          //console.log("POST LIST SET:", this.postList);
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageContent() {
      await this.setProfileType();
      await this.loadCampaign();
    this.loadCampaignStats();
      this.loadingOverlay = false;
      this.loadPosts();
    },
  },
  mounted() {
    this.loadingOverlay = true;
    this.loadingText = "LOADING...";
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  },
};
</script>
<style scoped>
.center-align {
  text-align: center;
}
.post-preview {
  float: left;
  padding: 10px;
  height: 150px;
  width: 150px;
  overflow: hidden;
  cursor: pointer;
}

.img-row {
  object-fit: cover;
}
</style>
